export default "__VITE_ASSET__jEQ0oFdX__"